import { useEffect } from 'react';
import { supabase } from './supabaseClient';

export function useTracker(page, userId) {
  useEffect(() => {
    const device = /Mobi|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
    const browser = navigator.userAgent.includes('Chrome') ? 'Chrome' : navigator.userAgent.includes('Safari') ? 'Safari' : navigator.userAgent.includes('Firefox') ? 'Firefox' : 'Other';
    supabase.from('page_views').insert({
      user_id: userId || null,
      page,
      referrer: document.referrer || null,
      device,
      browser,
    }).then(() => {});
  }, [page, userId]);
}
